module.exports = __webpack_public_path__ + "img/entrada_01.e18f2c70.jpg";